var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h4',{staticClass:"medium-blue"},[_vm._v(_vm._s(_vm.titulo))]),_c('h5',{staticClass:"medium-blue separacion"},[_vm._v(_vm._s(_vm.subTitulo))])])}
var staticRenderFns = []

export { render, staticRenderFns }